import axios from 'axios'
import { getTenant } from '../utils/tenant';
import { authService } from '../services/authService';
/**
 * =========================
 * BASE URL (MULTI-TENANT)
 * =========================
 */
//const API_BASE = `${window.location.protocol}//${window.location.hostname}:${process.env.REACT_APP_API_PORT}/api`;
//const API_BASE = process.env.REACT_APP_API_URL;
const API_BASE = process.env.REACT_APP_API_URL;
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

/**
 * =========================
 * ✅ AUTH INTERCEPTOR (CRITIQUE)
 * =========================
 */
api.interceptors.request.use((config) => {
  const tenant = getTenant() || 'public';
const token = localStorage.getItem(`access_token_${tenant}`);

  if (token) {
    config.headers = config.headers ?? {}
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

/**
 * =========================
 * ✅ GLOBAL ERROR HANDLING
 * =========================
 */
api.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newAccessToken = await authService.refreshAccessToken();

        if (!newAccessToken) {
          authService.logout();
          return Promise.reject(error);
        }

        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

        return api(originalRequest);
      } catch (err) {
        authService.logout();
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

/**
 * =========================
 * CLIENTS
 * =========================
 */
export const clientService = {
  async getAll() {
    const response = await api.get('/clients/')
    return response.data?.results ?? response.data
  },

  async getPaginated(params: any = {}) {
    const response = await api.get('/clients/', { params })
    return response.data
  },

  async getById(id: number) {
    const response = await api.get(`/clients/${id}/`)
    return response.data
  },

  async create(data: any) {
    const response = await api.post('/clients/', data)
    return response.data
  },

  async update(id: number, data: any) {
    const response = await api.patch(`/clients/${id}/`, data)
    return response.data
  },

  async delete(id: number) {
    await api.delete(`/clients/${id}/`)
  },

  async getContacts(clientId: number) {
    const response = await api.get('/contacts/', {
      params: { client: clientId },
    })
    return response.data?.results ?? response.data
  },
}

/**
 * =========================
 * CONTACTS
 * =========================
 */
export const contactService = {
  async getAll(clientId?: number) {
    const params = clientId ? { client: clientId } : {}
    const response = await api.get('/contacts/', { params })
    return response.data?.results ?? response.data
  },

  async getById(id: number) {
    const response = await api.get(`/contacts/${id}/`)
    return response.data
  },

  async create(data: any) {
    const response = await api.post('/contacts/', data)
    return response.data
  },

  async update(id: number, data: any) {
    const response = await api.patch(`/contacts/${id}/`, data)
    return response.data
  },

  async delete(id: number) {
    await api.delete(`/contacts/${id}/`)
  },
}

/**
 * =========================
 * FACTURES
 * =========================
 */
export const factureService = {
  async getAll() {
    const response = await api.get('/factures/')
    return response.data?.results ?? response.data
  },

  async getPaginated(params: any = {}) {
    const response = await api.get('/factures/', { params })
    return response.data
  },

  async getById(id: number) {
    const response = await api.get(`/factures/${id}/`)
    return response.data
  },

  async create(data: any) {
    const response = await api.post('/factures/', data)
    return response.data
  },

  async update(id: number, data: any) {
    const response = await api.patch(`/factures/${id}/`, data)
    return response.data
  },

  async delete(id: number) {
    await api.delete(`/factures/${id}/`)
  },
}

export default api
